import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import Img1 from "../../images/locationgcc/dxb/img_1.webp";
import Img2 from "../../images/locationgcc/dxb/img_2.webp";
import Img3 from "../../images/locationgcc/dxb/img_3.webp";
import Img4 from "../../images/locationgcc/dxb/img_4.webp";
import Img5 from "../../images/locationgcc/dxb/img_5.webp";
import Img6 from "../../images/locationgcc/dxb/img_6.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Brand(props) {
  return (
    <div className="brandsol p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="my-auto text-center"
          >
            <h2>A Glimpse to Some of Our Top Partnerships in Dubai</h2>
            <p>
              Being the most credible and future-driven{" "}
              <Link to="/mobile-app-development-company-dubai">
                app development company in Dubai
              </Link>
              , we got honor to work with top brands in UAE for developing
              user-friendly, highly rewarding digital products. With such
              diverse portfolio and trustworthiness, we promise to continue
              delivering high-end mobile app development services in Dubai along
              with full-scale launch and upscale strategy.
            </p>
            <div className="brand_box">
              <div className="brand_img">
                <LazyLoadImage
                  src={Img1}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img2}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img3}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img4}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img5}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img6}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Brand;
